const RECAPTCHA_SITE_KEY = '6LdMSfcjAAAAALeDu1vm1JI-8gRZBx5jY-H6h3Y8';

export { RECAPTCHA_SITE_KEY };
